import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <a href="/mentions-legales" className="legal-notice">Mentions Légales</a>
        <p>© 2024 Léa Martinez - Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
